/** @file The one per-channel layering kernel: replace/add of a sampled value onto a current value (W2-06). */
import { angle } from '@pose2d/math/angle';
import type { ChannelClass } from './channelClass';

/** Layers v onto cur with alpha by channel class: replace lerps (angles on the shortest arc), add is setup-relative. */
export function blendChannel(cls: ChannelClass, cur: number, v: number, setup: number, alpha: number, blend: 'replace' | 'add'): number {
  // Discrete (IK flags): a switch, never blended; the caller gates the layer by its threshold (W2-07).
  if (cls === 4) return v;
  // Absolute channels (slot colour, IK mix/softness) never add: add falls through to replace.
  if (blend === 'add' && cls !== 3) {
    if (cls !== 2) return cur + (v - setup) * alpha;
    // Scale multiplies by lerp(1, v / setup, alpha); with setup 0 the factor is unknowable from an absolute sample.
    return setup === 0 ? cur : cur * (1 + (v / setup - 1) * alpha);
  }
  if (alpha >= 1) return v;
  if (cls === 0) return cur + angle.wrap180(v - cur) * alpha;
  // Scale lerps linearly as well: a sign change (1 -> -1) collapses through 0, accepted (research §9.2 step 7).
  return cur + (v - cur) * alpha;
}
